<template>
  <um-page class="page-course-team">
   <ul class="teacher-list">
    <li v-for="item in textbookTeacherList" :key="item.id">
      <img :src="item.headimage | avatar" alt="">
      <div class="info">
        <div class="name">{{item.name}}</div>
        <div class="school">{{item.orgname}}</div>
        <overflowHidden :content="item.introduction"></overflowHidden>
      </div>
    </li>
   </ul>
  </um-page>
</template>

<script>
import { getTextbookDetail } from '@/api/courseApi.js'
import avatar from '@/mixins/avatar.js'
import overflowHidden from 'mobile/components/overflowHidden/overflowHidden.vue'
export default {
  name: 'page-course-team',
  mixins: [avatar],
  data () {
    return {
      textbookTeacherList: []
    }
  },
  computed: {
    courseId () {
      return this.$route.params.id
    },
  },
  created () {
    this.getTextbookDetail()
  },
  methods: {
    getTextbookDetail () {
      getTextbookDetail(this.courseId)
        .then(({result}) => {
          this.textbookTeacherList = result.textbookTeacherList || []
        })
    },
  },
  components: {
    overflowHidden
  }
}
</script>

<style lang="scss" scoped>
.teacher-list{
  padding: 8px 10px;
  li{
    display: flex;
    padding: 12px 0;
    img{
      width: 64px;
      height: 64px;
      border-radius: 100%;
      margin-right: 12px;
    }
    .info{
      flex: 1;
      .name{
        font-size: 16px;
        line-height: 24px;
        font-weight: bold;
      }
      .school{
        margin-top: 4px;
        margin-bottom: 8px;
        color: $--color-text-secondary;
      }
    }
  }
}
</style>